import React from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from 'components/Footer/Footer';
//import StoryTeller from 'components/StoryTeller/StoryTeller';
//import hostimg from 'Assets/storyimg2.png';
//import recordimg from 'Assets/storyimg1.png';
//import publishimg from 'Assets/publish@2x.jpg';
import home from 'Assets/home.svg';
//import Row from "react-bootstrap/Row";
//import Col from "react-bootstrap/Col";
//import Button from "components/Button/Button";
import { Button, Container, Row, Col, Tabs, Tab, Card, CardDeck, Table } from "react-bootstrap";
import { org_friendly_url, apiUrl, user_Status, user_Status_Ver } from 'Api/Api';
// , HeaderConfig, managed_contents
import axios from 'axios';
//import PkCreateBanner from 'components/Banner/PkCreatebanner';
//import footerBanner from 'Assets/footer-pk-hero.png';
//import footerBanner from 'Assets/footer-banner@2x.jpg';
import bus_brands from 'Assets/bus_brands.png';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
//import SpotLightPk from 'components/spotlightedPK/spotlightedPK';
import { local_routes } from 'utils/Routes';
import { stripe_plans } from 'utils/stripe_plans';

import { pricing_matrix } from 'utils/pricing_matrix';

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';

import UserContext from 'store/UserContext';

//import {Elements} from '@stripe/react-stripe-js';


import ReactTooltip from 'react-tooltip';

import { Link } from 'react-router-dom';

import HubspotForm from 'react-hubspot-form'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
import {loadStripe} from '@stripe/stripe-js/pure';
loadStripe.setLoadParameters({advancedFraudSignals: false});
const stripePromise = loadStripe(process.env.REACT_APP_PK_STRIPE_KEY);

const hubspot_portalId = '6817434';
const hubspot_formId = '689dadb1-8a7b-44c1-b9f8-bea31e54b6fa';

class Pricing extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    
    let basic_plan_info_month = {
      plan_id: 'basic',
      compare_price_display: '',
      price_display: 'Free',
      interval_display: <React.Fragment>&nbsp;</React.Fragment>,
      extra_header_text: 'No credit card required',
      interval: 'month',
      nickname: 'Basic',
      plan_text_display: 'For individuals that would like to share their stories with everyone'
    };

    let basic_plan_info_year = {
      plan_id: 'basic',
      compare_price_display: '',
      price_display: 'Free',
      interval_display: <React.Fragment>&nbsp;</React.Fragment>,
      extra_header_text: 'No credit card required',
      interval: 'year',
      nickname: 'Basic',
      plan_text_display: 'For individuals that would like to share their stories with everyone'
    };

    let enterprise_plan_info_month = {
      plan_id: 'enterprise',
      compare_price_display: '',
      price_display: 'Coming Soon',
      interval_display: <React.Fragment>&nbsp;</React.Fragment>,
      extra_header_text: 'Contact us for early access',
      interval: 'month',
      nickname: 'Enterprise',
      plan_text_display: 'For organizations with multiple teams'
    };

    let enterprise_plan_info_year = {
      plan_id: 'enterprise',
      compare_price_display: '',
      price_display: 'Coming Soon',
      interval_display: <React.Fragment>&nbsp;</React.Fragment>,
      extra_header_text: 'Contact us for early access',
      interval: 'year',
      nickname: 'Enterprise',
      plan_text_display: 'For organizations with multiple teams'
    };
    
    this.state = {
      display_all_flag: false,
      loading: true,
      show_signup_modal: false,
      verification_modal_show: false,
      stripe_plans: {
        pro: {
          month: [basic_plan_info_month],
          year: [basic_plan_info_year]
        },
        team: {
          month: [],
          year: []
        }
      }
    };

    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    //this.presentation_relative_url = 'presentations/how-to-make-a-presentation-with-pechakucha-create';
    
    // setup stripe plans
    //console.log("YO",process.env.REACT_APP_PK_ENV,local_routes,stripe_plans);
    if (stripe_plans[process.env.REACT_APP_PK_ENV]) {
      let tmp_stripe_plans = stripe_plans[process.env.REACT_APP_PK_ENV];
      let plan_id_array = Object.keys(tmp_stripe_plans);
      for (let plan_id of plan_id_array) {
        let tmp_amount = tmp_stripe_plans[plan_id].amount / 100;
        let tmp_price_display = tmp_amount.toLocaleString("en-US", {style:"currency", currency:"USD"});
        let tmp_interval_display = 'per month';
        let compare_price_display = '';
        let extra_header_text = '';
        let most_popular = false;
        let nickname = tmp_stripe_plans[plan_id].nickname;
        if (nickname === 'NPO Pro') {
          nickname = 'Student / Non-Profit Pro'
        }
        if (nickname === 'NPO Team') {
          nickname = 'School / Non-Profit Team'
        }
        if (tmp_stripe_plans[plan_id].type === 'team') {
          extra_header_text = "Up to 50 users per team";
        }
        if (tmp_stripe_plans[plan_id].nickname === 'Business Pro') {
          most_popular = true;
        }
        if (tmp_stripe_plans[plan_id].interval === 'year') {
          tmp_amount = tmp_stripe_plans[plan_id].amount / 100 / 12;
          tmp_price_display = tmp_amount.toLocaleString("en-US", {style:"currency", currency:"USD"});
          if (tmp_stripe_plans[plan_id].compare_plan) {
            let tmp_compare_amount = tmp_stripe_plans[tmp_stripe_plans[plan_id].compare_plan].amount / 100
            compare_price_display = tmp_compare_amount.toLocaleString("en-US", {style:"currency", currency:"USD"});
          }
          tmp_interval_display = 'per month paid annually';
        }
        this.state.stripe_plans[tmp_stripe_plans[plan_id].type][tmp_stripe_plans[plan_id].interval].push({
          plan_id,
          most_popular,
          extra_header_text,
          compare_price_display,
          price_display: tmp_price_display,
          interval_display: tmp_interval_display,
          ...tmp_stripe_plans[plan_id],
          nickname
        });
      }
    }
    
    this.state.stripe_plans['team']['month'].push(enterprise_plan_info_month);
    this.state.stripe_plans['team']['year'].push(enterprise_plan_info_year);
  
    this.plan_text_display = {
      pro: 'For individuals that may want to share their stories privately',
      team: 'For teams that need advanced sharing features'
    }
    
    this.stripe_object = null;
    
    this.form_anchor_ref = React.createRef();
  }
  
  
  componentDidMount = async function () {
    this.stripe_object = await stripePromise;
    
    this.setState({
      loading: false
    });
    
  }
  
  handleBuyClick = async (plan_info) => {
    let plan_id = plan_info.plan_id;
    
    if (plan_info.plan_id === 'enterprise') {
      this.form_anchor_ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    
    if (!this.context.user_info.entity_uuid) {
      console.error("NO user!");
      window.localStorage.setItem('loginOrigin',this.props.location.pathname);
      this.setState({
        show_signup_modal: true
      });
      return;
    }
    if (this.context.user_info.status_code !== 1) {
      console.error("NO user is not verified!");
        this.setState({
          verification_modal_show: true
        });
      return;
    }
    if (!this.stripe_object) {
      console.error("NO stripe object!");
      return;
    }
    this.setState({
      loading: true
    });
    let params = {
      cancel_url: window.location.href,
      success_url: window.location.origin+local_routes.accountsettings+'?refresh',
      stripe_plan_id: plan_id
    };
    let checkout_session_id_response = await axios.post(`${apiUrl}users/${this.context.user_info.entity_uuid}/getCheckoutSessionId`, params);
    console.log("Got session ID from stripe",checkout_session_id_response.data);
    await this.stripe_object.redirectToCheckout({
      sessionId: checkout_session_id_response.data.checkout_session_id
    });
    console.log("What now?");
  }
  
  renderPricingMatrix = () => {
    //let contents = [];
    let sub_table_contents = [];
    let spacer_row =
      <tr style={{ border: 'none', marginBottom: "10px" }}>
        <td>&nbsp;</td>
      </tr>;
    
    let tmp_pricing_matrix = [];
    if (this.state.display_all_flag) {
      tmp_pricing_matrix = pricing_matrix;
    } else {
      tmp_pricing_matrix = [pricing_matrix[0]];
    }
    
    tmp_pricing_matrix.forEach( (matrix_block, matrix_block_index) => {
      //let sub_table_contents = [];
      let thead =
        <thead>
          <tr>
            {Object.keys(matrix_block.columns).map( (element,index) => (
              <td
                key={index}
                style={{ fontWeight: 'bolder', border: '1px solid #dee2e6', backgroundColor: this.context.theme === 'dark' ? 'gray' : 'lightgray' }}
              >
                {matrix_block.columns[element]}
              </td>
            ))}
          </tr>
        </thead>;
      let tbody =
        <tbody>
            {Object.keys(matrix_block.matrix).map( (element,index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #dee2e6' }}>{element}</td>
                {Object.keys(matrix_block.matrix[element]).map( (element2,index2) => (
                  <td key={index2} style={{ border: '1px solid #dee2e6' }}>
                    {
                      typeof matrix_block.matrix[element][element2] === 'boolean' ?
                        matrix_block.matrix[element][element2] ? <i className="fa fa-check-circle" aria-hidden="true"></i> : ''
                        : matrix_block.matrix[element][element2]
                    }
                  </td>
                ))}
              </tr>
            ))}
            {spacer_row}
        </tbody>;
      
      sub_table_contents.push(<React.Fragment key={matrix_block_index}>{thead}{tbody}</React.Fragment>);
      //contents.push(<hr/>);
    });
    
    let contents = <Table variant={this.context.theme}>{sub_table_contents}</Table>;
    return contents;
  }

  
  renderPlanCard = (plan_info,index) => {
    
    let button_tooltip = '';
    let button_text = 'Buy It';
    if (plan_info.plan_id === 'basic') {
      button_text = 'Sign Up';
      button_tooltip = 'Please signup/login before continuing';
      if (!user_Status) {
        button_tooltip = 'Please signup/login before continuing';
      } else if (user_Status_Ver !== "1") {
        button_text = 'Verify';
        button_tooltip = 'Please verify your email address to unlock PK Create features';
      } else {
        button_text = <React.Fragment><i className="fa fa-check"/> You are already an All Star</React.Fragment>;
        button_tooltip = 'You are already a customer - Thank you!';
      }
    } else if (plan_info.plan_id === 'enterprise') {
      button_text = 'Get in Touch';  
      button_tooltip = 'Contact us to find out more!';
    } else {
      if (!user_Status) {
        button_tooltip = 'Please signup/login before continuing';
      } else if (user_Status_Ver !== "1") {
        button_tooltip = 'Please verify your email address before continuing';
      } else if (this.context.user_info.stripe_customer_id) {
        button_tooltip = 'You are already a customer - Thank you!';
      }
    }
    
    let border_radius = "25px";
    if (plan_info.most_popular) {
      border_radius = "50px";
    }
    
    let content =
      <React.Fragment key={index}>
          <Card style={{ borderRadius: "25px", maxWidth: "400px" }} bg={this.context.theme} border={"pkprimary"}>
            <Card.Header style={{ borderTopLeftRadius: "25px", borderTopRightRadius: "25px" }}>
              <center>
                <p style={{ fontWeight: "bold", fontSize: "larger" }}>{plan_info.nickname}</p>
                <p>
                  { plan_info.compare_price_display &&
                    <span style={{ marginRight: "5px", fontWeight: "bold", fontSize: "175%", textDecoration: 'line-through', color: 'lightsteelblue' }}>{plan_info.compare_price_display}</span>
                  }
                  <span style={{ fontWeight: "bold", fontSize: "175%" }}>{plan_info.price_display}</span>
                </p>
                <p style={{ fontSize: "smaller" }}>{plan_info.interval_display}</p>
                <p style={{ marginTop: "5px", fontSize: "75%", color: "gray" }}>{plan_info.extra_header_text || <React.Fragment>&nbsp;</React.Fragment>}</p>
              </center>
            </Card.Header>
            <Card.Body>
              <center>
                <p style={{ minHeight: "50px", marginBottom: "10px" }}>{plan_info.plan_text_display || this.plan_text_display[plan_info.type]}</p>
                
                  <div data-tip={button_tooltip}>
                    <Button
                      disabled={(plan_info.plan_id === 'basic' && user_Status_Ver === "1") || (this.context.user_info.stripe_customer_id && plan_info.plan_id !== 'enterprise' && (this.context.user_info.account_level && this.context.user_info.account_level === 'private'))}
                      //disabled={(plan_info.plan_id === 'basic' && user_Status_Ver === "1")}
                      style={{ width: "90%" }}
                      variant="pkprimary"
                      onClick={() => this.handleBuyClick(plan_info)}
                    >
                      {button_text}
                    </Button>

                  </div>
                
              </center>
            </Card.Body>
          </Card>  
      </React.Fragment>;
    return content;
  }
  
  manageAccountSubscriptionClick = async () => {
    this.setState({
        loading: true
    });
    
    let params = {
        return_url: window.location.href+'?refresh'
    }
    
    let billing_portal_url_response = await axios.post(`${apiUrl}users/${this.context.user_info.entity_uuid}/getBillingPortalUrl`, {}, { params });
    
    if (billing_portal_url_response.data.billing_portal_url) {
        window.location.href = billing_portal_url_response.data.billing_portal_url;
        return;
    } else {
        console.error("ERROR - could not get billing portal url");
    }
    
    this.setState({
        loading: false
    });
  }
  

  render() {

    if (this.state.loading || (user_Status && !this.context.user_info.entity_uuid)) {
      return (
          <FullPageSpinner />
      );
    }
    
    let already_customer = '';
    if (this.context.user_info.stripe_customer_id) {
      already_customer =
        <p>You are already a customer! To manage your subscription, please visit <Link to={local_routes.accountsettings}>Account Settings</Link></p>;
    }

    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>PechaKucha PK Create Pricing</title>
          <meta name="description" content="PK Create is presentation software that makes it easy to make Pecha Kucha presentations. Sign up for your free Pecha Kucha account." />
        </Helmet>
        <Container>
          <Row style={{ marginTop: "20px", marginBottom: "10px" }} className="justify-content-center">
            <Col xs={"auto"}>
              <h2>Choose the plan that's right for you</h2>
              {already_customer}
            </Col>
          </Row>
          <Row style={{ marginBottom: "20px" }} className="pricing-plan-types">
            <Col>
                  <Tabs style={{ marginBottom: "10px" }} className="justify-content-center" variant="pills" defaultActiveKey="individual">
                    <Tab eventKey="individual" title="Individual Plans">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.pro.month.map( (element,index) => {
                          return this.renderPlanCard(element,index);
                        })}
                      </CardDeck>
                    </Tab>
                    <Tab eventKey="business" title="Team Plans">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.team.month.map( (element,index) => {
                          return this.renderPlanCard(element,index);
                        })}
                      </CardDeck>
                    </Tab>
                  </Tabs>
              {/*
              <Tabs style={{ marginTop: "10px" }} className="justify-content-start" defaultActiveKey="individual">
                <Tab eventKey="individual" title="Individual Plans">
                  <Tabs style={{ marginBottom: "10px" }} className="justify-content-center" variant="pills" defaultActiveKey="year">
                    <Tab eventKey="month" title="Monthly">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.pro.month.map( (element,index) => {
                          return this.renderPlanCard(element,index);
                        })}
                      </CardDeck>
                    </Tab>
                    <Tab eventKey="year" title="Annually">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.pro.year.map( (element,index) => {
                          return this.renderPlanCard(element,index);
                        })}
                      </CardDeck>
                    </Tab>
                  </Tabs>
                </Tab>
                <Tab eventKey="business" title="Team Plans">
                  <Tabs style={{ marginBottom: "10px" }} className="justify-content-center" variant="pills" defaultActiveKey="year">
                    <Tab eventKey="month" title="Monthly">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.team.month.map( (element,index) => (
                          this.renderPlanCard(element,index) 
                        ))}
                      </CardDeck>
                    </Tab>
                    <Tab eventKey="year" title="Annually">
                      <CardDeck className="justify-content-center">
                        {this.state.stripe_plans.team.year.map( (element,index) => {
                          return this.renderPlanCard(element,index);
                        })}
                      </CardDeck>
                    </Tab>
                  </Tabs>
        
                </Tab>
              </Tabs>
              */}
            </Col>
          </Row>
          <Row style={{ marginBottom: "10px", marginTop: "5px" }} className="justify-content-center">
            <h2>Compare Plans</h2>
          </Row>
          <Row className="justify-content-center">
            {this.renderPricingMatrix()}
          </Row>
          <Row style={{ marginTop: "-30px", marginBottom: "20px" }} className="justify-content-center">
            <Button
              onClick={() => this.setState({ display_all_flag: !this.state.display_all_flag })}
              variant="pkprimary"
            >
              {this.state.display_all_flag ?
                <span><i className="fa fa-minus" aria-hidden="true"></i> Hide All Features</span>
              :
                <span><i className="fa fa-plus" aria-hidden="true"></i> Show All Features</span>
              }
            </Button>
          </Row>
          <Row style={{ marginBottom: "10px", minHeight: "200px", backgroundColor: this.context.theme === 'dark' ? '#111111' : "#f3f3f3" }} className="align-items-center justify-content-center">
            <p style={{ fontSize: "larger", marginTop: "45px" }}>Thousands of companies are using PechaKucha to help tell their stories</p>
            <img style={{ maxWidth: "75%", marginBottom: "35px" }} src={bus_brands}/>
          </Row>
          <Row style={{ marginTop: "20px" }} className="align-items-center justify-content-center">
              <p style={{ fontSize: "175%" }}>People love PechaKucha</p>
          </Row>
          <Row style={{ marginBottom: "20px" }} className="align-items-center justify-content-center">
              <p>PK Create helps you create short, powerful talks that are engaging, memorable, and easy to share.</p>
          </Row>
          <Row style={{ marginBottom: "50px" }} className="">
            <CardDeck>
              <Card bg={this.context.theme}>
                <Card.Body>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>&nbsp;
                  When a job candidate makes a PK presentation, it helps us learn more about their whole person, something that’s not as easy to learn from resumes or social media profiles. It’s another input to help us match the right candidate with the right job.
                  &nbsp;<i className="fa fa-quote-right" aria-hidden="true"></i>
                </Card.Body>
                <Card.Footer>
                  <p style={{ fontWeight: "bolder" }}>Kevin Gibson</p>
                  <p style={{ fontSize: "smaller", fontWeight: "lighter" }}>CEO Latin America, Robert Walters (San Paulo)</p>
                </Card.Footer>
              </Card>
            
              <Card bg={this.context.theme}>
                <Card.Body>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>&nbsp;
                  Kohler stands for leading edge design and technology, and PechaKucha provides an exceptional platform that has helped us build a great relationship with the design fraternity over the years.
                  &nbsp;<i className="fa fa-quote-right" aria-hidden="true"></i>
                </Card.Body>
                <Card.Footer>
                  <p style={{ fontWeight: "bolder" }}>Salil Sadanandan</p>
                  <p style={{ fontSize: "smaller", fontWeight: "lighter" }}>President South Asia & EMEA, Kohler (India)</p>
                </Card.Footer>
              </Card>

              <Card bg={this.context.theme}>
                <Card.Body>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>&nbsp;
                  We’ve licensed PechaKucha for a series of events for the company that I work for and all my colleagues have fallen in love with the format.
                  &nbsp;<i className="fa fa-quote-right" aria-hidden="true"></i>
                </Card.Body>
                <Card.Footer>
                  <p style={{ fontWeight: "bolder" }}>Ilay Bal Arslan</p>
                  <p style={{ fontSize: "smaller", fontWeight: "lighter" }}>Supervisor, ExxonMobile (Czech Republic)</p>
                </Card.Footer>
              </Card>
            </CardDeck>

          </Row>
          <hr/>
          <Row ref={this.form_anchor_ref} style={{ marginBottom: "10px", marginTop: "40px", minHeight: "200px" }} className="">
            <Col xs={12} md={6}>
              <p style={{ fontSize: "200%" }}>Have a question about our plans?</p>
              <p style={{ marginBottom: "5px" }}>Check out our FAQs{/*, or use this form to request more information about PechaKucha!*/}</p>
              <a target="_blank" rel="noopener noreferrer" href="https://pechakucha.zendesk.com/hc/en-us/categories/360002876531-PechaKucha-com-PK-Create-">
                <Button
                  variant="pkprimary"
                >
                  See FAQs
                </Button>
              </a>

            </Col>
            {/*
            <Col xs={12} md={6} style={{ backgroundColor: "lightgray", paddingTop: "10px" }}>
              <HubspotForm
                portalId={hubspot_portalId}
                formId={hubspot_formId}
                onSubmit={() => console.log('Submit!')}
                onReady={(form) => console.log('Form ready!')}
                loading={<div>Loading...</div>}
              />
            </Col>
            */}
          </Row>
        </Container>
        
        { !user_Status &&
          <SignupModal
            show={this.state.show_signup_modal}
            onHide={() => this.setState({show_signup_modal:false})}
            reload={true}
          >
          </SignupModal>
        }
        
        { user_Status_Ver !== "1" &&
          <VerificationModal
              show={this.state.verification_modal_show}
              onHide={() => this.setState({ verification_modal_show: false})}
          />
        
        }
        
        <div className="pk-create-footer">
          <Footer
            homeImg={home}
            homeImgRef="/"
            breadcrumbSubPage="Pricing"
          />
        </div>
        <ReactTooltip/>
      </React.Fragment>
    );
  }
}

export default Pricing;
